{
  "distancePerM": 1,
  "speedBonus": { "fromSpeed": 20, "toSpeed": 40, "maxMultiplier": 2 },
  "comboStep": 0.5,
  "comboCap": 5,
  "failedLanding": 500,
  "crashPenalty": { "small": 0, "medium": 50, "large": 150 },
  "escapeBonus": 2000
}
